/**
 * My API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpResponse, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

import { CreateManualPositionRequestMatching } from '@coin/shared/core/util-models-v2';
import { CreateTeamMemberAvailabilityPeriod } from '@coin/shared/core/util-models-v2';
import { DepartmentAdjustments } from '@coin/shared/core/util-models-v2';
import { DepartmentBreadcrumbItem } from '@coin/shared/core/util-models-v2';
import { FieldValues } from '@coin/shared/core/util-models-v2';
import { PageOfDepartment } from '@coin/shared/core/util-models-v2';
import { PageOfDepartmentAdjustments } from '@coin/shared/core/util-models-v2';
import { PageOfPositionRequestMatchingEmployee } from '@coin/shared/core/util-models-v2';
import { PageOfString } from '@coin/shared/core/util-models-v2';
import { PageOfTeamMember } from '@coin/shared/core/util-models-v2';
import { PageOfTeamMemberAvailabilityAggregation } from '@coin/shared/core/util-models-v2';
import { PageOfTeamMemberAvailabilityPeriod } from '@coin/shared/core/util-models-v2';
import { PositionRequest } from '@coin/shared/core/util-models-v2';
import { PositionRequestMatching } from '@coin/shared/core/util-models-v2';
import { Report } from '@coin/shared/core/util-models-v2';
import { ResetPositionRequestMatching } from '@coin/shared/core/util-models-v2';
import { TeamMemberDetails } from '@coin/shared/core/util-models-v2';
import { TransactionStatusOfExportStatusMetadata } from '@coin/shared/core/util-models-v2';
import { UpdateDepartmentAdjustments } from '@coin/shared/core/util-models-v2';
import { UpdatePositionRequestFinancialData } from '@coin/shared/core/util-models-v2';
import { UpdateTeamMemberAvailability } from '@coin/shared/core/util-models-v2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration } from '../configuration';
import { BaseService, RequestArgs, RequestOptions } from '../api.base.service';

export interface AcceptMatchingPositionRequestMatchingParams {
  employeeId?: string;
  positionRequestId?: string;
}

export interface CreateManualMatchingPositionRequestMatchingParams {
  createManualPositionRequestMatching?: CreateManualPositionRequestMatching;
}

export interface CreateTeamMemberAvailabilityPeriodsParams {
  teamMemberId: string;
  disableElevatedPermissions?: boolean;
  createTeamMemberAvailabilityPeriod?: CreateTeamMemberAvailabilityPeriod;
}

export interface DeleteDepartmentAdjustmentDepartmentAdjustmentsParams {
  /** The department of which the adjustments should be returned of. */
  department: string;
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: string;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: string;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: string;
  disableElevatedPermissions?: boolean;
}

export interface DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams {
  teamMemberId: string;
  id: string;
  disableElevatedPermissions?: boolean;
}

export interface ExportDepartmentAnalyticsReportExportParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  filename?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface ExportListViewTeamMembersExportParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  priorityEmployeeId?: string;
  priorityPositionRequestId?: string;
  filename?: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface ExportTeamAnalyticsReportExportParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  filename?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface GetAvailableEmployeesForMatchingPositionRequestMatchingParams {
  positionRequestId: string;
  /** Search term to search an employee by firstname, lastname, or GID */
  searchTerm?: string;
  page?: number;
  size?: number;
}

export interface GetDepartmentAdjustmentDepartmentAdjustmentsParams {
  /** The department of which the adjustments should be returned of. */
  department: string;
  /** The year and month to first include adjustments for. */
  startDate: string;
  /** The year and month to no longer include adjustments for. */
  endDate: string;
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: string;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: string;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: string;
  disableElevatedPermissions?: boolean;
}

export interface GetDepartmentAdjustmentsDepartmentAdjustmentsParams {
  /** The year and month to first include adjustments for. */
  startDate: string;
  /** The year and month to no longer include adjustments for. */
  endDate: string;
  /** The department of which the adjustments should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  businessArea?: Array<string>;
  /** If values should be shown as FTE or HC */
  headcountDisplayType?: 'Headcount' | 'FullTimeEquivalent';
  /** The cost center of which the adjustments should be returned of. */
  costCenter?: Array<string>;
  /** The legal entity of which the adjustments should be returned of. */
  areCode?: Array<string>;
  /** The depth structure of which the adjustments should be returned of. */
  depthStructure?: Array<string>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface GetDepartmentBreadcrumbDepartmentBreadcrumbParams {
  orgCode: string;
}

export interface GetDepartmentReportAnalyticsFieldValuesParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The organisation of which field values should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface GetDepartmentReportAnalyticsReportsParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface GetDetailsTeamMembersParams {
  id: string;
  startDate: string;
  endDate: string;
  disableElevatedPermissions?: boolean;
}

export interface GetMatchingsForPositionRequestPositionRequestMatchingParams {
  positionRequestId: string;
  /** Parameter to optionally filter by Acknowledge State */
  acknowledgeStatesFilter?: Array<'Open' | 'Accepted' | 'Rejected' | 'Irrelevant'>;
  /** Search term to search an employee by firstname, lastname, or GID */
  searchTerm?: string;
}

export interface GetTeamReportAnalyticsFieldValuesParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The organisation of which field values should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface GetTeamReportAnalyticsReportsParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  disableElevatedPermissions?: boolean;
}

export interface HeadcountOverviewQueryBusinessAreasBusinessAreasParams {
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface IsReadOnlyModeUltimoPhaseParams {
  disableElevatedPermissions?: boolean;
}

export interface PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The business-areas to query departments of. */
  businessArea?: Array<string>;
  search?: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface PageTeamDepartmentCodesTeamDepartmentCodesParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The business-areas to query departments of. */
  businessArea?: Array<string>;
  search?: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface PostUltimoPhaseStartDateOverrideUltimoPhaseParams {
  body?: string;
}

export interface QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams {
  /** The organisation of which the departments should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  headcountDisplayType: 'Headcount' | 'FullTimeEquivalent';
  showEmployees?: boolean;
  showNewRequests?: boolean;
  showAdjustments?: boolean;
  changeDisplayType?: 'Absolute' | 'Percentage';
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The organisation which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  showEmployees?: boolean;
  showNewRequests?: boolean;
  priorityEmployeeId?: string;
  priorityPositionRequestId?: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryFieldValuesTeamMemberFieldValuesParams {
  field:
    | 'AreCode'
    | 'OrgCode'
    | 'BusinessArea'
    | 'CountryTitle'
    | 'Region'
    | 'Location'
    | 'Gid'
    | 'CostCenter'
    | 'DepthStructure'
    | 'DepthStructureText'
    | 'ContractStatus'
    | 'WorkforceType';
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  /** The organisation of which the team members should be returned of. */
  departments?: Array<string>;
  /** The department which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface QueryIrrelevantAnalyticsTeamMemberParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryRelevantAnalyticsTeamMemberParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryRelevantPositionRequestsAnalyticsTeamMemberParams {
  /** The organisation of which a report should be returned of. */
  department: string;
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  /** The are code of the team member to filter for. */
  areCode?: Array<string>;
  /** The org code of the team member to filter for. */
  orgCode?: Array<string>;
  /** The org code the team member\&#39;s org code has to start with. */
  orgCodeStartsWith?: string;
  /** The business area of the team member. */
  businessArea?: Array<string>;
  /** The region of the team member. */
  region?: Array<string>;
  /** The country of the team member. */
  countryTitle?: Array<string>;
  /** The location of the team member. */
  location?: Array<string>;
  /** The country cost type of the team member. */
  countryCostType?: Array<'BestCost' | 'HighCost'>;
  /** The cost center of the team member. */
  costCenter?: Array<string>;
  /** The depth structure of the team member. */
  depthStructure?: Array<string>;
  /** The depth structure text of the team member. */
  depthStructureText?: Array<string>;
  /** The workforce type of the team member. */
  workforceType?: Array<
    | 'Employee'
    | 'Apprentice'
    | 'Intern'
    | 'Student'
    | 'BlueCollar'
    | 'LeasedWhiteCollar'
    | 'LeasedBlueCollar'
    | 'Internal'
  >;
  /** The contract status of the team member. */
  contractStatus?: Array<'Terminated' | 'Dormant' | 'Active' | 'Other'>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface QueryTeamMemberAvailabilityPeriodsParams {
  teamMemberId: string;
  startDate: string;
  endDate: string;
  page?: number;
  size?: number;
  disableElevatedPermissions?: boolean;
}

export interface QueryTeamMembersParams {
  /** The inclusive time at which to start aggregating headcounts. */
  startDate: string;
  /** The inclusive time at which to end aggregating headcounts. */
  endDate: string;
  search?: string;
  /** The department of which the team members should be returned of. */
  departments?: Array<string>;
  /** The department which should be excluded from the returned list. */
  departmentsExcluding?: Array<string>;
  page?: number;
  size?: number;
  orderBy?: 'Asc' | 'Desc';
  property?: string;
  disableElevatedPermissions?: boolean;
}

export interface RejectMatchingPositionRequestMatchingParams {
  employeeId?: string;
  positionRequestId?: string;
}

export interface ResetMatchingPositionRequestMatchingParams {
  resetPositionRequestMatching?: ResetPositionRequestMatching;
}

export interface UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams {
  disableElevatedPermissions?: boolean;
  updateDepartmentAdjustments?: UpdateDepartmentAdjustments;
}

export interface UpdateManyTeamMemberAvailabilitiesTeamMembersParams {
  id: string;
  startDate: string;
  endDate: string;
  disableElevatedPermissions?: boolean;
  updateTeamMemberAvailability?: Array<UpdateTeamMemberAvailability>;
}

export interface UpdatePositionRequestFinancialDataOverviewPositionRequestParams {
  id: string;
  updatePositionRequestFinancialData?: UpdatePositionRequestFinancialData;
}

@Injectable({
  providedIn: 'root'
})
export class HeadcountOverviewService extends BaseService {
  constructor(
    httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string | string[],
    @Optional() configuration: Configuration
  ) {
    super(httpClient, basePath, configuration);
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public acceptMatchingPositionRequestMatching(
    requestParameters?: AcceptMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: AcceptMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: AcceptMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public acceptMatchingPositionRequestMatching(
    requestParameters?: AcceptMatchingPositionRequestMatchingParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/headcount/customer/overview/matching/accept`,
      accepts: [],
      query: { employeeId: requestParameters?.employeeId, positionRequestId: requestParameters?.positionRequestId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createManualMatchingPositionRequestMatching(
    requestParameters?: CreateManualMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: CreateManualMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: CreateManualMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public createManualMatchingPositionRequestMatching(
    requestParameters?: CreateManualMatchingPositionRequestMatchingParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/headcount/customer/overview/matching`,
      accepts: [],
      body: requestParameters?.createManualPositionRequestMatching,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: CreateTeamMemberAvailabilityPeriodsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: CreateTeamMemberAvailabilityPeriodsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: CreateTeamMemberAvailabilityPeriodsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public createTeamMemberAvailabilityPeriods(
    requestParameters?: CreateTeamMemberAvailabilityPeriodsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    this.checkRequired('createTeamMemberAvailabilityPeriods', { teamMemberId });
    return this.sendRequest(args, {
      method: 'post',
      path: `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods`,
      accepts: [],
      query: { disableElevatedPermissions: requestParameters?.disableElevatedPermissions },
      body: requestParameters?.createTeamMemberAvailabilityPeriod,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: DeleteDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: DeleteDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: DeleteDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: DeleteDepartmentAdjustmentDepartmentAdjustmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    this.checkRequired('deleteDepartmentAdjustmentDepartmentAdjustments', { department });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/headcount/customer/overview/department-adjustments`,
      accepts: [],
      query: {
        Department: department,
        CostCenter: requestParameters?.costCenter,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods(
    requestParameters?: DeleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriodsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    const id = requestParameters?.id;
    this.checkRequired('deleteTeamMemberAvailabilityPeriodTeamMemberAvailabilityPeriods', { teamMemberId, id });
    return this.sendRequest(args, {
      method: 'delete',
      path: `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: [],
      query: { disableElevatedPermissions: requestParameters?.disableElevatedPermissions }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public deleteUltimoPhaseStartDateOverrideUltimoPhase(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'delete',
      path: `/headcount/customer/overview/ultimo-phase/start-date-override`,
      accepts: []
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: ExportDepartmentAnalyticsReportExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: ExportDepartmentAnalyticsReportExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: ExportDepartmentAnalyticsReportExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportDepartmentAnalyticsReportExport(
    requestParameters?: ExportDepartmentAnalyticsReportExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('exportDepartmentAnalyticsReportExport', { department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/analytics-report-export/department`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        Filename: requestParameters?.filename,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        ShowAdjustments: requestParameters?.showAdjustments,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportListViewTeamMembersExport(
    requestParameters?: ExportListViewTeamMembersExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportListViewTeamMembersExport(
    requestParameters?: ExportListViewTeamMembersExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportListViewTeamMembersExport(
    requestParameters?: ExportListViewTeamMembersExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportListViewTeamMembersExport(
    requestParameters?: ExportListViewTeamMembersExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('exportListViewTeamMembersExport', { startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/list-view-team-member-export`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Departments: requestParameters?.departments,
        DepartmentsExcluding: requestParameters?.departmentsExcluding,
        StartDate: startDate,
        EndDate: endDate,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        ShowAdjustments: requestParameters?.showAdjustments,
        PriorityEmployeeId: requestParameters?.priorityEmployeeId,
        PriorityPositionRequestId: requestParameters?.priorityPositionRequestId,
        Filename: requestParameters?.filename,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public exportTeamAnalyticsReportExport(
    requestParameters?: ExportTeamAnalyticsReportExportParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TransactionStatusOfExportStatusMetadata>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: ExportTeamAnalyticsReportExportParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TransactionStatusOfExportStatusMetadata>>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: ExportTeamAnalyticsReportExportParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TransactionStatusOfExportStatusMetadata>>;
  public exportTeamAnalyticsReportExport(
    requestParameters?: ExportTeamAnalyticsReportExportParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('exportTeamAnalyticsReportExport', { department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/analytics-report-export/team`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        Filename: requestParameters?.filename,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        ShowAdjustments: requestParameters?.showAdjustments,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: GetAvailableEmployeesForMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfPositionRequestMatchingEmployee>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: GetAvailableEmployeesForMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfPositionRequestMatchingEmployee>>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: GetAvailableEmployeesForMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfPositionRequestMatchingEmployee>>;
  public getAvailableEmployeesForMatchingPositionRequestMatching(
    requestParameters?: GetAvailableEmployeesForMatchingPositionRequestMatchingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    this.checkRequired('getAvailableEmployeesForMatchingPositionRequestMatching', { positionRequestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/matching/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/available-employees`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { SearchTerm: requestParameters?.searchTerm, Page: requestParameters?.page, Size: requestParameters?.size }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<DepartmentAdjustments>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<DepartmentAdjustments>>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentDepartmentAdjustmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<DepartmentAdjustments>>;
  public getDepartmentAdjustmentDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentDepartmentAdjustmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('getDepartmentAdjustmentDepartmentAdjustments', { department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/department-adjustments/details`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        CostCenter: requestParameters?.costCenter,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfDepartmentAdjustments>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfDepartmentAdjustments>>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfDepartmentAdjustments>>;
  public getDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: GetDepartmentAdjustmentsDepartmentAdjustmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('getDepartmentAdjustmentsDepartmentAdjustments', { startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/department-adjustments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Departments: requestParameters?.departments,
        DepartmentsExcluding: requestParameters?.departmentsExcluding,
        StartDate: startDate,
        EndDate: endDate,
        BusinessArea: requestParameters?.businessArea,
        HeadcountDisplayType: requestParameters?.headcountDisplayType,
        CostCenter: requestParameters?.costCenter,
        AreCode: requestParameters?.areCode,
        DepthStructure: requestParameters?.depthStructure,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: GetDepartmentBreadcrumbDepartmentBreadcrumbParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<DepartmentBreadcrumbItem>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: GetDepartmentBreadcrumbDepartmentBreadcrumbParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<DepartmentBreadcrumbItem>>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: GetDepartmentBreadcrumbDepartmentBreadcrumbParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<DepartmentBreadcrumbItem>>>;
  public getDepartmentBreadcrumbDepartmentBreadcrumb(
    requestParameters?: GetDepartmentBreadcrumbDepartmentBreadcrumbParams,
    ...args: RequestArgs
  ): Observable<any> {
    const orgCode = requestParameters?.orgCode;
    this.checkRequired('getDepartmentBreadcrumbDepartmentBreadcrumb', { orgCode });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/department-breadcrumb/${this.configuration.encodeParam({ name: 'orgCode', value: orgCode, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: GetDepartmentReportAnalyticsFieldValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FieldValues>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: GetDepartmentReportAnalyticsFieldValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FieldValues>>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: GetDepartmentReportAnalyticsFieldValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FieldValues>>;
  public getDepartmentReportAnalyticsFieldValues(
    requestParameters?: GetDepartmentReportAnalyticsFieldValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const field = requestParameters?.field;
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('getDepartmentReportAnalyticsFieldValues', { field, department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/analytics-field-values/department/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        search: requestParameters?.search,
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        ShowAdjustments: requestParameters?.showAdjustments,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDepartmentReportAnalyticsReports(
    requestParameters?: GetDepartmentReportAnalyticsReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Report>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: GetDepartmentReportAnalyticsReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Report>>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: GetDepartmentReportAnalyticsReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Report>>;
  public getDepartmentReportAnalyticsReports(
    requestParameters?: GetDepartmentReportAnalyticsReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    this.checkRequired('getDepartmentReportAnalyticsReports', { department, startDate, endDate, headcountDisplayType });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/headcount/overview/analytics-reports/department`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        HeadcountDisplayType: headcountDisplayType,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        ShowAdjustments: requestParameters?.showAdjustments,
        ChangeDisplayType: requestParameters?.changeDisplayType,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getDetailsTeamMembers(
    requestParameters?: GetDetailsTeamMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<TeamMemberDetails>;
  public getDetailsTeamMembers(
    requestParameters?: GetDetailsTeamMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<TeamMemberDetails>>;
  public getDetailsTeamMembers(
    requestParameters?: GetDetailsTeamMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<TeamMemberDetails>>;
  public getDetailsTeamMembers(requestParameters?: GetDetailsTeamMembersParams, ...args: RequestArgs): Observable<any> {
    const id = requestParameters?.id;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('getDetailsTeamMembers', { id, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/details`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        StartDate: startDate,
        EndDate: endDate,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: GetMatchingsForPositionRequestPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Array<PositionRequestMatching>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: GetMatchingsForPositionRequestPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Array<PositionRequestMatching>>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: GetMatchingsForPositionRequestPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Array<PositionRequestMatching>>>;
  public getMatchingsForPositionRequestPositionRequestMatching(
    requestParameters?: GetMatchingsForPositionRequestPositionRequestMatchingParams,
    ...args: RequestArgs
  ): Observable<any> {
    const positionRequestId = requestParameters?.positionRequestId;
    this.checkRequired('getMatchingsForPositionRequestPositionRequestMatching', { positionRequestId });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/matching/${this.configuration.encodeParam({ name: 'positionRequestId', value: positionRequestId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/matchings`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        AcknowledgeStatesFilter: requestParameters?.acknowledgeStatesFilter,
        SearchTerm: requestParameters?.searchTerm
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: GetTeamReportAnalyticsFieldValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FieldValues>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: GetTeamReportAnalyticsFieldValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FieldValues>>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: GetTeamReportAnalyticsFieldValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FieldValues>>;
  public getTeamReportAnalyticsFieldValues(
    requestParameters?: GetTeamReportAnalyticsFieldValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const field = requestParameters?.field;
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('getTeamReportAnalyticsFieldValues', { field, department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/analytics-field-values/team/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        search: requestParameters?.search,
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        ShowAdjustments: requestParameters?.showAdjustments,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTeamReportAnalyticsReports(
    requestParameters?: GetTeamReportAnalyticsReportsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<Report>;
  public getTeamReportAnalyticsReports(
    requestParameters?: GetTeamReportAnalyticsReportsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<Report>>;
  public getTeamReportAnalyticsReports(
    requestParameters?: GetTeamReportAnalyticsReportsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<Report>>;
  public getTeamReportAnalyticsReports(
    requestParameters?: GetTeamReportAnalyticsReportsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    this.checkRequired('getTeamReportAnalyticsReports', { department, startDate, endDate, headcountDisplayType });
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/headcount/overview/analytics-reports/team`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        HeadcountDisplayType: headcountDisplayType,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        ShowAdjustments: requestParameters?.showAdjustments,
        ChangeDisplayType: requestParameters?.changeDisplayType,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public headcountOverviewQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewQueryBusinessAreasBusinessAreasParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public headcountOverviewQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewQueryBusinessAreasBusinessAreasParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public headcountOverviewQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewQueryBusinessAreasBusinessAreasParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public headcountOverviewQueryBusinessAreasBusinessAreas(
    requestParameters?: HeadcountOverviewQueryBusinessAreasBusinessAreasParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/customer/headcount/overview/business-areas`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public isReadOnlyModeUltimoPhase(
    requestParameters?: IsReadOnlyModeUltimoPhaseParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<boolean>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: IsReadOnlyModeUltimoPhaseParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<boolean>>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: IsReadOnlyModeUltimoPhaseParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<boolean>>;
  public isReadOnlyModeUltimoPhase(
    requestParameters?: IsReadOnlyModeUltimoPhaseParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/ultimo-phase`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: { disableElevatedPermissions: requestParameters?.disableElevatedPermissions }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes(
    requestParameters?: PageAnalyticsDepartmentCodesAnalyticsDepartmentCodesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('pageAnalyticsDepartmentCodesAnalyticsDepartmentCodes', { startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/analytics-department-codes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        StartDate: startDate,
        EndDate: endDate,
        BusinessArea: requestParameters?.businessArea,
        search: requestParameters?.search,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: PageTeamDepartmentCodesTeamDepartmentCodesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfString>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: PageTeamDepartmentCodesTeamDepartmentCodesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfString>>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: PageTeamDepartmentCodesTeamDepartmentCodesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfString>>;
  public pageTeamDepartmentCodesTeamDepartmentCodes(
    requestParameters?: PageTeamDepartmentCodesTeamDepartmentCodesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('pageTeamDepartmentCodesTeamDepartmentCodes', { startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/team-department-codes`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        StartDate: startDate,
        EndDate: endDate,
        BusinessArea: requestParameters?.businessArea,
        search: requestParameters?.search,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: PostUltimoPhaseStartDateOverrideUltimoPhaseParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<string>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: PostUltimoPhaseStartDateOverrideUltimoPhaseParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<string>>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: PostUltimoPhaseStartDateOverrideUltimoPhaseParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<string>>;
  public postUltimoPhaseStartDateOverrideUltimoPhase(
    requestParameters?: PostUltimoPhaseStartDateOverrideUltimoPhaseParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/headcount/customer/overview/ultimo-phase/start-date-override`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.body,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfDepartment>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfDepartment>>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfDepartment>>;
  public queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedDepartmentAvailabilitiesAvailabilityAggregationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    const headcountDisplayType = requestParameters?.headcountDisplayType;
    this.checkRequired('queryAggregatedDepartmentAvailabilitiesAvailabilityAggregation', {
      department,
      startDate,
      endDate,
      headcountDisplayType
    });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/availability-aggregation/departments`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        ShowAdjustments: requestParameters?.showAdjustments,
        HeadcountDisplayType: headcountDisplayType,
        ChangeDisplayType: requestParameters?.changeDisplayType,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation(
    requestParameters?: QueryAggregatedTeamMemberAvailabilitiesAvailabilityAggregationParams,
    ...args: RequestArgs
  ): Observable<any> {
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('queryAggregatedTeamMemberAvailabilitiesAvailabilityAggregation', { startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/availability-aggregation/team-members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Departments: requestParameters?.departments,
        DepartmentsExcluding: requestParameters?.departmentsExcluding,
        StartDate: startDate,
        EndDate: endDate,
        ShowEmployees: requestParameters?.showEmployees,
        ShowNewRequests: requestParameters?.showNewRequests,
        PriorityEmployeeId: requestParameters?.priorityEmployeeId,
        PriorityPositionRequestId: requestParameters?.priorityPositionRequestId,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: QueryFieldValuesTeamMemberFieldValuesParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<FieldValues>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: QueryFieldValuesTeamMemberFieldValuesParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<FieldValues>>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: QueryFieldValuesTeamMemberFieldValuesParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<FieldValues>>;
  public queryFieldValuesTeamMemberFieldValues(
    requestParameters?: QueryFieldValuesTeamMemberFieldValuesParams,
    ...args: RequestArgs
  ): Observable<any> {
    const field = requestParameters?.field;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('queryFieldValuesTeamMemberFieldValues', { field, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/team-member-field-values/${this.configuration.encodeParam({ name: 'field', value: field, in: 'path', style: 'simple', explode: false, dataType: "'AreCode' | 'OrgCode' | 'BusinessArea' | 'CountryTitle' | 'Region' | 'Location' | 'Gid' | 'CostCenter' | 'DepthStructure' | 'DepthStructureText' | 'ContractStatus' | 'WorkforceType'", dataFormat: undefined })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        search: requestParameters?.search,
        Departments: requestParameters?.departments,
        DepartmentsExcluding: requestParameters?.departmentsExcluding,
        StartDate: startDate,
        EndDate: endDate,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantAnalyticsTeamMemberParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantAnalyticsTeamMemberParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantAnalyticsTeamMemberParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryIrrelevantAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantAnalyticsTeamMemberParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('queryIrrelevantAnalyticsTeamMember', { department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/availability-aggregation/team-members/irrelevant`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryIrrelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryIrrelevantPositionRequestsAnalyticsTeamMemberParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('queryIrrelevantPositionRequestsAnalyticsTeamMember', { department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/availability-aggregation/team-members/irrelevant-position-requests`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: QueryRelevantAnalyticsTeamMemberParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: QueryRelevantAnalyticsTeamMemberParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: QueryRelevantAnalyticsTeamMemberParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryRelevantAnalyticsTeamMember(
    requestParameters?: QueryRelevantAnalyticsTeamMemberParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('queryRelevantAnalyticsTeamMember', { department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/availability-aggregation/team-members/relevant`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryRelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTeamMemberAvailabilityAggregation>;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryRelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityAggregation>>;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryRelevantPositionRequestsAnalyticsTeamMemberParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityAggregation>>;
  public queryRelevantPositionRequestsAnalyticsTeamMember(
    requestParameters?: QueryRelevantPositionRequestsAnalyticsTeamMemberParams,
    ...args: RequestArgs
  ): Observable<any> {
    const department = requestParameters?.department;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('queryRelevantPositionRequestsAnalyticsTeamMember', { department, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/availability-aggregation/team-members/relevant-position-requests`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        Department: department,
        StartDate: startDate,
        EndDate: endDate,
        AreCode: requestParameters?.areCode,
        OrgCode: requestParameters?.orgCode,
        OrgCodeStartsWith: requestParameters?.orgCodeStartsWith,
        BusinessArea: requestParameters?.businessArea,
        Region: requestParameters?.region,
        CountryTitle: requestParameters?.countryTitle,
        Location: requestParameters?.location,
        CountryCostType: requestParameters?.countryCostType,
        CostCenter: requestParameters?.costCenter,
        DepthStructure: requestParameters?.depthStructure,
        DepthStructureText: requestParameters?.depthStructureText,
        WorkforceType: requestParameters?.workforceType,
        ContractStatus: requestParameters?.contractStatus,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: QueryTeamMemberAvailabilityPeriodsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTeamMemberAvailabilityPeriod>;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: QueryTeamMemberAvailabilityPeriodsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTeamMemberAvailabilityPeriod>>;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: QueryTeamMemberAvailabilityPeriodsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTeamMemberAvailabilityPeriod>>;
  public queryTeamMemberAvailabilityPeriods(
    requestParameters?: QueryTeamMemberAvailabilityPeriodsParams,
    ...args: RequestArgs
  ): Observable<any> {
    const teamMemberId = requestParameters?.teamMemberId;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('queryTeamMemberAvailabilityPeriods', { teamMemberId, startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'teamMemberId', value: teamMemberId, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availability-periods`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        StartDate: startDate,
        EndDate: endDate,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public queryTeamMembers(
    requestParameters?: QueryTeamMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PageOfTeamMember>;
  public queryTeamMembers(
    requestParameters?: QueryTeamMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PageOfTeamMember>>;
  public queryTeamMembers(
    requestParameters?: QueryTeamMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PageOfTeamMember>>;
  public queryTeamMembers(requestParameters?: QueryTeamMembersParams, ...args: RequestArgs): Observable<any> {
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('queryTeamMembers', { startDate, endDate });
    return this.sendRequest(args, {
      method: 'get',
      path: `/headcount/customer/overview/team-members`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      query: {
        search: requestParameters?.search,
        Departments: requestParameters?.departments,
        DepartmentsExcluding: requestParameters?.departmentsExcluding,
        StartDate: startDate,
        EndDate: endDate,
        Page: requestParameters?.page,
        Size: requestParameters?.size,
        OrderBy: requestParameters?.orderBy,
        Property: requestParameters?.property,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      }
    });
  }

  /**
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public recalculateEmployeeAvailability(
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<string>;
  public recalculateEmployeeAvailability(
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<string>>;
  public recalculateEmployeeAvailability(
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<string>>;
  public recalculateEmployeeAvailability(...args: RequestArgs): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/customer/headcount/overview/availability/recalculate`,
      accepts: ['text/plain', 'application/json', 'text/json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public rejectMatchingPositionRequestMatching(
    requestParameters?: RejectMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: RejectMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: RejectMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public rejectMatchingPositionRequestMatching(
    requestParameters?: RejectMatchingPositionRequestMatchingParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/headcount/customer/overview/matching/reject`,
      accepts: [],
      query: { employeeId: requestParameters?.employeeId, positionRequestId: requestParameters?.positionRequestId }
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public resetMatchingPositionRequestMatching(
    requestParameters?: ResetMatchingPositionRequestMatchingParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: ResetMatchingPositionRequestMatchingParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: ResetMatchingPositionRequestMatchingParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public resetMatchingPositionRequestMatching(
    requestParameters?: ResetMatchingPositionRequestMatchingParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/headcount/customer/overview/matching/reset`,
      accepts: [],
      body: requestParameters?.resetPositionRequestMatching,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public updateDepartmentAdjustmentsDepartmentAdjustments(
    requestParameters?: UpdateDepartmentAdjustmentsDepartmentAdjustmentsParams,
    ...args: RequestArgs
  ): Observable<any> {
    return this.sendRequest(args, {
      method: 'post',
      path: `/headcount/customer/overview/department-adjustments`,
      accepts: [],
      query: { disableElevatedPermissions: requestParameters?.disableElevatedPermissions },
      body: requestParameters?.updateDepartmentAdjustments,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: UpdateManyTeamMemberAvailabilitiesTeamMembersParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<any>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: UpdateManyTeamMemberAvailabilitiesTeamMembersParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpResponse<any>>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: UpdateManyTeamMemberAvailabilitiesTeamMembersParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<undefined>
  ): Observable<HttpEvent<any>>;
  public updateManyTeamMemberAvailabilitiesTeamMembers(
    requestParameters?: UpdateManyTeamMemberAvailabilitiesTeamMembersParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    const startDate = requestParameters?.startDate;
    const endDate = requestParameters?.endDate;
    this.checkRequired('updateManyTeamMemberAvailabilitiesTeamMembers', { id, startDate, endDate });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/headcount/customer/overview/team-members/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}/availabilities`,
      accepts: [],
      query: {
        StartDate: startDate,
        EndDate: endDate,
        disableElevatedPermissions: requestParameters?.disableElevatedPermissions
      },
      body: requestParameters?.updateTeamMemberAvailability,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }

  /**
   * @param requestParameters
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: UpdatePositionRequestFinancialDataOverviewPositionRequestParams,
    observe?: 'body',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<PositionRequest>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: UpdatePositionRequestFinancialDataOverviewPositionRequestParams,
    observe?: 'response',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpResponse<PositionRequest>>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: UpdatePositionRequestFinancialDataOverviewPositionRequestParams,
    observe?: 'events',
    reportProgress?: boolean,
    options?: RequestOptions<'text/plain' | 'application/json' | 'text/json'>
  ): Observable<HttpEvent<PositionRequest>>;
  public updatePositionRequestFinancialDataOverviewPositionRequest(
    requestParameters?: UpdatePositionRequestFinancialDataOverviewPositionRequestParams,
    ...args: RequestArgs
  ): Observable<any> {
    const id = requestParameters?.id;
    this.checkRequired('updatePositionRequestFinancialDataOverviewPositionRequest', { id });
    return this.sendRequest(args, {
      method: 'patch',
      path: `/headcount/customer/overview/position-request/${this.configuration.encodeParam({ name: 'id', value: id, in: 'path', style: 'simple', explode: false, dataType: 'string', dataFormat: 'uuid' })}`,
      accepts: ['text/plain', 'application/json', 'text/json'],
      body: requestParameters?.updatePositionRequestFinancialData,
      consumes: ['application/json-patch+json', 'application/json', 'text/json', 'application/*+json']
    });
  }
}
